export const UserConstant = {
    GET_CHAPTER: 'GET_CHAPTER',
    CHAPTER_LIST: 'CHAPTER_LIST',
    GET_CHAPTER_STATUS: "GET_CHAPTER_STATUS",
    SET_CHAPTER_STATUS: "SET_CHAPTER_STATUS",
    PRE_ASSESSMENT_QUESTIONS: 'PRE_ASSESSMENT_QUESTIONS',
    SET_PRE_ASSESSMENT_QUESTIONS: 'SET_PRE_ASSESSMENT_QUESTIONS',
    INSERT_PRE_ASSESSMENT_QUESTIONS: "INSERT_PRE_ASSESSMENT_QUESTIONS",
    POST_ASSESSMENT_QUESTIONS: 'POST_ASSESSMENT_QUESTIONS',
    SET_POST_ASSESSMENT_QUESTIONS: 'SET_POST_ASSESSMENT_QUESTIONS',
    INSERT_POST_ASSESSMENT_QUESTIONS: "INSERT_POST_ASSESSMENT_QUESTIONS",
    GET_CHAPTER_DETAIL: "GET_CHAPTER_DETAIL",
    SET_CHAPTER_DETAIL: "SET_CHAPTER_DETAIL",
    INSERT_CHAPTERS_QUESTIONS: "INSERT_CHAPTERS_QUESTIONS",
    SET_MESSAGE: "SET_MESSAGE",
    INSERT_VIDEO_TIME: "INSERT_VIDEO_TIME"

}